"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findChildGeoQuestionsNames = exports.isLinkedQuestion = void 0;

var _ramda = require("ramda");

var _questions = require("../constants/questions");

var isLinkedQuestion = function isLinkedQuestion(field) {
  var isLinked = false;
  var _field$settings = field.settings,
      settings = _field$settings === void 0 ? {} : _field$settings;
  var settingsKeys = (0, _ramda.keys)(settings) || [];
  settingsKeys.forEach(function (key) {
    if ((0, _ramda.contains)(key, _questions.LINK_KEYS)) {
      isLinked = true;
    }
  });
  return isLinked;
};

exports.isLinkedQuestion = isLinkedQuestion;

var findChildGeoQuestionsNames = function findChildGeoQuestionsNames() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var chengedQuestionType = arguments.length > 1 ? arguments[1] : undefined;
  var formValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var childQuestionsTypes = _questions.CHILD_QUESTIONS_TYPES[chengedQuestionType];
  var geoFields = [];
  fields.forEach(function (_ref) {
    var type = _ref.type,
        field = _ref.field;

    if ((0, _ramda.contains)(type, childQuestionsTypes) && !!formValues[type]) {
      geoFields.push(field);
    }
  });
  return geoFields;
};

exports.findChildGeoQuestionsNames = findChildGeoQuestionsNames;